import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UsersModel } from '../users.model';
import { UsersService } from '../users.service';
import { T2CardComponent } from '../../../trip2-theme/components/t2-card/t2-card.component';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';

@Component({
  selector: 'app-user-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent implements OnInit, AfterViewInit, OnChanges {

  private data = new UsersModel();
  protected mode = 'Add New User';
  private errorMessageAlert: string;
  private showAlert = false;
  private payorArray = [];
  private defaultProviders = [];
  public rolesArray: any;
  private gridData: any;
  private loadingAfterSave = false;
  @Input() date: Date;
  @Input() usersId: number;
  @Input() dateOfBirth: string;
  @Input() searchUser: string;
  @Output() notify: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() cancel: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @ViewChild('modalChngPsswd') private modalChngPsswd: T2CardComponent;
  @ViewChild('cardUsersCreate') cardUsersCreate: T2CardComponent;
  protected currentUser = JSON.parse(localStorage.getItem('currentUser'));
  private isClient = this.currentUser.isClient;
  protected providers: any[];
  private userTypes: any[];
  private userProviders: any[];
  private UserTypeId = 0;
  public rolesArrayTemp: any[];
  isDHP = JSON.parse(localStorage.getItem('isDHP'));

  constructor(
    private service: UsersService,
    private toastrAlertHelper: ToastrAlertHelper
  ) {
    this.loadDateFormat();
  }

  ngOnInit() {
    this.service.getRoles()
      .subscribe(
        data => {
          this.rolesArray = data;
        }
      );

      this.getAllUserType();
  }

  init_params() {
    this.loadPayor();
    this.loadData();

    if (this.isClient) {
      this.data.payorid = JSON.parse(localStorage.getItem('currentUser')).payorid;
    }

    this.UserTypeId = this.getUserType();
    if (this.UserTypeId === 2) {
      this.data.usertypeid = 2;
    }
  }

  /**
   *Description:
   */
  ngAfterViewInit() {
    // this.modalChngPsswd.open();
  }

  /**
   * @Description:
   */
  loadData() {
    if (this.usersId !== 0) {
      this.cardUsersCreate.viewProgressBar(true);
      this.service
      .getUser(this.usersId)
      .finally(() => this.cardUsersCreate.viewProgressBar(false))
      .subscribe(
        data => {
          this.data = (data);
          this.data.dob = data.dobformatted;
          this.mode = 'Edit User - ' + this.data.fullname;
          this.getAllProviders();
          this.onChangeUserType(data.usertypeid);
        });
    } else {
      this.getAllProviders();
      this.data.isactive = true;
      if (this.isDHP) {
        this.data.usertypeid = 1;
      }
    }
  }

  /**
   * @Description:
   */
  loadDateFormat() {
    const dateString = this.dateOfBirth;
    const dateValue = new Date(dateString);
    this.date = typeof (this.dateOfBirth) !== 'undefined' ? dateValue : new Date();
  }

  /**
   * @Description:
   */
  cleanPayor() {
    this.data.payorid = null;
  }

  /**
   * @Description:
   */
  loadPayor() {
    this.service
    .getPayorList()
    .subscribe(
      data => {
        this.payorArray = data;
      });
  }

  /**
   * @Description:
   * @param data
   */
  sendNotify(data: any) {
    this.loadingAfterSave = false;
    this.toastrAlertHelper.success(data.message);
    if (data.success) {
      this.notify.emit(data);
    }
  }

  /**
   * @Description:
   * @param message
   */
  onsuccesschange(message) {
    this.toastrAlertHelper.success(message);
  }

  createAction(): void {}


  /**
   * @Descrption:
   * @param error
   */
  errorNotificatio(error) {
    this.loadingAfterSave = false;
    this.showAlert = true;
    this.toastrAlertHelper.error(error.message);
    this.errorMessageAlert = error.message;
  }

  /**
   * @Description:
   */
  saveAction() {
    this.cardUsersCreate.viewProgressBar(true);
    this.loadingAfterSave = true;
    if (this.data.usertypeid === 2) {
      this.data.UserProviders = this.userProviders;
    } else {
      this.data.UserProviders = [];
      this.data.defaultproviderid = undefined;
    }
    if (this.usersId === 0) {
      this.service
      .registerUser(this.data)
      .finally(() => {
        this.cardUsersCreate.viewProgressBar(false);
      })
      .subscribe(
        res => {
          this.sendNotify(res);
        },
        err => {
          this.errorNotificatio(err);
        },
      );
    } else {
      delete this.data['role'];
      delete this.data['payor'];
      delete this.data['company'];
      delete this.data['userproviders'];
      this.service
        .putData(this.data)
        .finally(() => {
          this.cardUsersCreate.viewProgressBar(false);
        })
        .subscribe(
          res => this.sendNotify(res),
          err => {
            this.errorNotificatio(err);
          }
        );
    }
  }

  /**
   * @Description:
   */
  cancelCreateEdit() {
    this.cancel.emit(true);
  }

  /**
   * @Description:
   */
  onChangePassword() {
    this.modalChngPsswd.open();
  }

  /**
   * @Description:
   * @param $event
   */
  onCloseModal($event) {
    this.modalChngPsswd.close();
  }

  /**
   * @Description:
   */
  getAllProviders() {
    this.service
    .getAllProviders()
    .subscribe(
      data => {
        this.providers = data;
        this.proceprocessUserProvider(this.data);
      }
    );
  }

  /**
   * @Description:
   */
  getAllUserType() {
    this.service.getAllUserType().subscribe(
      data => {
        this.userTypes = data;
        setTimeout(() => {
          this.onChangeUserType(this.data.usertypeid);
        }, 100);

      }
    );
  }

  /**
   * @Description:
   * @param items
   */
  shareCheckedList(items: any) {
    this.userProviders = [];
    this.defaultProviders = items;
    if (this.data.defaultproviderid) {
      if (!items.includes(this.data.defaultproviderid)) {
        this.data.defaultproviderid = undefined;
      }
    }
    items.forEach((data) => {
      this.userProviders.push({
        'ProviderId': data.companyid
      });
    });
  }

  /**
   * @Description:
   * @param data
   */
  proceprocessUserProvider(data: any) {
    this.userProviders = [];
    if (data.userproviders !== undefined) {
      data.userproviders.forEach((row) => {
        this.userProviders.push({
          'ProviderId': row.providerid
        });
        this.providers.forEach((dat) => {
          if (dat.companyid === row.providerid) {
            dat.assign = true;
            this.defaultProviders.push(dat);
          }
        });
      });
    }
  }

  /**
   * @Description:
   * @returns {number}
   */
  getUserType(): number {
    const obj = JSON.parse(localStorage.getItem('currentUser'));
    return obj.usertypeid;
  }

  /**
   * @Description:
   * @param {number} $event
   */
  onChangeUserType($event: number) {
    if (this.rolesArray !== undefined && this.rolesArray !== null) {
      if (this.rolesArray.length > 0) {
        this.rolesArrayTemp = this.rolesArray.filter((row) => {
          return row.roletypeid === Number($event);
        });
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['usersId']) {
      this.init_params();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/users/create/create.component.ts